/**
 * Shared hook for calculating legend grid columns
 */

import { useMemo } from 'react';

interface UseGridColumnsOptions {
  itemCount: number;
  maxItemsPerColumn?: number;
  maxColumns?: number;
}

export const useGridColumns = ({
  itemCount,
  maxItemsPerColumn = 10,
  maxColumns = 2,
}: UseGridColumnsOptions): string => {
  return useMemo(() => {
    const numberOfColumns = Math.min(maxColumns, Math.ceil(itemCount / maxItemsPerColumn));
    return `grid-cols-${numberOfColumns}`;
  }, [itemCount, maxItemsPerColumn, maxColumns]);
};
